import { createContext } from 'react';
import { AuthenticationContextData } from '../models/authentication';
import AuthenticationStore from "../store/authentication";

const AuthenticationContext = createContext<AuthenticationContextData>(AuthenticationStore);

export default AuthenticationContext;
    